const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Edit Videos Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the Analyze resource
 * @argument {Videos} Videos injected to gain access to the Videos resource
 */
app.controller('editVideo', ['Application', 'Authorization', 'Analyze', 'Videos', 'AdminContent', 'Viewables', 'AccessHelper', 'SurveyHelper', '$scope', '$translate', '$filter', function(Application, Authorization, Analyze, Videos, AdminContent, Viewables, AccessHelper, SurveyHelper, $scope, $translate, $filter) {
    var self = this;
    self.confirmAIOnce = false

    var routeParameters = Application.navigation.getRouteParameters();
    self.newVideo = routeParameters.id === 'new' || !routeParameters.id;
    self.features = Application.features.flags();
    self.allowance = {
      create_video: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'videos_create']], ['admin', 'creator', 'collaborator']),
      edit_video: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'videos_edit'], ['admin', 'content', 'my_content_edit']], ['admin', 'creator', 'collaborator']),
      add_survey: self.features.surveys && AccessHelper.isAllowed(['admin', 'surveys'], null, ['admin']),
      add_partner: self.features.enable_partners && AccessHelper.isAllowed(['admin', 'content'], null, ['admin']),
    };

    if ((!self.newVideo && !self.allowance.edit_video) || (self.newVideo && !self.allowance.create_video)) {
      Application.navigation.goTo('/explore');
      return;
    }
    

    self.authtoken = Authorization.getAuthToken();
    self.user = self.authtoken.user;
    self.editSaved = true;
    self.backLocation = Application.navigation.history[Application.navigation.history.length - 2];
    self.denied = false;
    self.archiveInfo = {};

    var locationChange = $scope.$on('$locationChangeStart', function(event) {
      if (self.editSaved) {
        // Allow the route change to progress
        locationChange();
        Application.messaging.clearMessages('trackstate');
        return;
      }

      // Halt the route change and question the action
      self.navigationPath = {};
      self.navigationPath.targetPath = Application.navigation.getPath();
      self.navigationPath.targetSearch = Application.navigation.getUrlParameters();
      self.navigationPath.targetHash = Application.navigation.getHash();

      event.preventDefault();
      self.showDeparture = true;
      self.onLocationChange = function() {
        locationChange();
        Application.messaging.clearMessages('trackstate');
      };
    });

    var trackState = self.trackState = Application.trackState.get();
    if (trackState && trackState.ttl < new Date().valueOf()) {
      trackState = self.trackState = false;
    }
    if (trackState) {
      var trackTitle = trackState.trackTitle;
      if (self.newVideo) {
        $translate('edit.videos.track_add', trackTitle).then(function(value) {
          Application.messaging.addMessage({type: 'insidetrack', text: value, trackstate: true, link: '/edit/tracks/' + trackState.track});
        });
      }
      if (!self.newVideo) {
        $translate('edit.videos.track_edit', trackTitle).then(function(value) {
          Application.messaging.addMessage({type: 'insidetrack', text: value, trackstate: true, link: '/edit/tracks/' + trackState.track});
        });
      }
    }

    var video = {};
    video.type = 'video';
    video.tags = [];
    video.images = {};
    video.explore_hide = trackState ? true : false;
    video.linked_category = [];
    video.privacy_collaborators = [];
    video.allow_comments = false;
    video.use_generative_ai = !!Application.features.flags().enable_generative_ai;
    self.showCollaborators = false;
    self.activeTab = 'add';

    self.mediumOpts = {
      'targetBlank': true,
      'toolbar': {
        'buttons': ['bold', 'italic', 'underline', 'anchor', 'h1', 'h2', 'h3', 'quote', 'unorderedlist', 'orderedlist']
      }
    };

    self.navigationDirectory = {
      'add': {
        next: 'details',
        previous: null,
        required: ['link']
      },
      'details': {
        next: trackState ? 'settings' : 'images',
        previous: 'add',
        required: ['title', 'author', 'description']
      },
      'images': {
        next: 'categories',
        previous: 'details',
        required: null
      },
      'categories': {
        next: 'settings',
        previous: 'images',
        required: null
      },
      'settings': {
        next: 'preview',
        previous: trackState ? 'details' : 'categories',
        required: null
      },
      'preview': {
        next: null,
        previous: 'settings',
        required: null
      }
    };

    self.nextSection = function(item) {
      var nextClicked = item ? false : true;
      var item = item ? self.navigationDirectory[item].previous : self.activeTab;
      var next = self.navigationDirectory[item].next;
      var missing = '';
      var allow = true;
      var skip_missing = false;

      if (item === 'settings' && self.video.transcoding) {
        Application.messaging.addMessage({text: self.translations['edit.videos.preview_transcoding'], duration: 17});
        return;
      }

      var findIssues = function(check) {
        var current = self.navigationDirectory[check];
        if (self.video.use_generative_ai && check === 'details') {
          current.required = current.required.filter((x) => x !== 'description');
        }
        if (current.required) {
          for (var i = 0; i < current.required.length; i++) {
            if (!self.video[current.required[i]]) {
              allow = false;
              missing = missing + ' ' + (current.required[i] === 'link' ? 'video' : current.required[i]) + ',';
            }
          }
        }
        if (current.previous) {
          findIssues(current.previous);
        }
      };

      findIssues(item);

      if (allow && next) {
        //save users ai choice
        if(item === 'add' && next === 'details' && !self.useGenerativeAIChosen) {
          self.setNoWatch();
          self.saveProgress(next)
        }
        if (
          item === 'details' &&
          next === 'images' &&
          self.video.use_generative_ai &&
          self.video.text_generation_status === 'in_progress'
        ) {
          self.saveProgress(next);
        }
        self.useGenerativeAIChosen = true;
        if (self.newVideo || !nextClicked) {
          self.activeTab = next;
          Application.scrollTop();
          return;
        }
        Application.scrollTop();
        self.activeTab = next;
      }

      if (missing && !skip_missing) {
        Application.messaging.addMessage({type: 'error', text: self.translations['edit.general.notification_fieldsMissing'] + missing.slice(0, -1) + '.', duration: 5});
      }
    };

    self.updateVtt = function(addition) {
      var toUpload = addition === 'removed' ? [] : [addition];
      if (self.video.vtt_files && self.video.vtt_files.length) {
        toUpload = toUpload.concat(self.video.vtt_files);
      }
      if(self.user.is_collaborator) {
        self.video.approval_required = true;
        self.video.approved = false;
      }
      Videos.update({
        subresource: self.video._id,
        fields: 'vtt_files'
      }, {vtt_files: toUpload}).$promise.then(function(video) {
        Analyze.record({resource: 'modifications'}, {document: video._id, type: 'video'});
        Application.analyticsProvider.trackEvent('video_updated', {content: video._id, content_type: 'video', title: video.title});
        self.video.vtt_files = video.vtt_files;
        if (addition === 'removed') {
          Application.messaging.addMessage({type: 'success', text: self.translations['edit.videos.cc_removed'], duration: 5});
          return;
        }
        Application.messaging.addMessage({type: 'success', text: self.translations['edit.videos.cc_added'], duration: 5});
      }).catch(function(error) {
        self.updateIndicator = false;
        if (error.data && error.data.status === 401 && error.data.message) {
          Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
        }
      });
    };

    self.saveProgress = function(next, publish) {
      if (!self.video._id) {
        return;
      }

      if (publish) {
        self.video.draft = false;
      }

      self.updateIndicator = true;
      if(self.user.is_collaborator) {
        self.video.approval_required = true;
        self.video.approved = false;
      }

      let videoCopy = Object.assign({}, self.video);
      if (self.video.use_generative_ai && next === 'details') {
        delete videoCopy.description;
        delete videoCopy.tags;
      }
      delete videoCopy.transcoding;

      return Videos.update({
        subresource: self.video._id,
        fields: 'title,description,type,author,duration,tags,images,link,source,source_id,video_type,type,user,linked_category,explore_hide,draft,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,private,cover_justification,featured_justification,createdAt,vtt_files,rating_configuration,rating_configuration,rating_configuration,allow_comments,text_generation_status,use_generative_ai'
      }, videoCopy).$promise.then(function(video) {
        if (video.use_generative_ai) {
          self.getGeneratedText();
        }
        self.setNoWatch();
        Analyze.record({resource: 'modifications'}, {document: video._id, type: 'video'});
        Application.analyticsProvider.trackEvent('video_updated', {content: video._id, content_type: 'video', title: video.title});
        self.updateIndicator = false;
        self.editSaved = true;
        function goToTrack() {
          Application.navigation.goTo('/edit/tracks/' + trackState.track);
          Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.video_savedPt1'] + ' ' + $filter('limitTo')(self.video.title, 25) + (self.video.title.length > 25 ? '[...]' : '') + ' ' + self.translations['modules.notifications.video_savedPt2'], duration: 5});
        };
        if (trackState && !next) {
          goToTrack();
          return;
        }
        if (publish) {
          if (trackState) {
            goToTrack();
            return;
          }
          setTimeout(function() {
            Application.navigation.goTo('/view/videos/' + self.video._id);
            Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.video_publishedPt1'] + ' ' + $filter('limitTo')(self.video.title, 25) + (self.video.title.length > 25 ? '[...]' : '') + ' ' + self.translations['modules.notifications.video_publishedPt2'], duration: 5});
          }, 500);
          return;
        }
        if (self.video.title) {
          Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.video_savedPt1'] + ' ' + $filter('limitTo')(self.video.title, 25) + (self.video.title.length > 25 ? '[...]' : '') + ' ' + self.translations['modules.notifications.video_savedPt2'], duration: 5});
        }
      }).catch(function(error) {
        self.updateIndicator = false;
        if (error.data && error.data.status === 401 && error.data.message) {
          Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
          return;
        }
        Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.content_issue_updating'], duration: 5});
        console.log('Error in update: ', error);
      });
    };

    self.saveDraft = function(next) {
      if (!self.video._id) {
        return;
      }
      self.beforeUpdate = JSON.parse(JSON.stringify(self.video));
      delete self.video.link;
      delete self.video.transcoding;
      self.updateIndicator = true;

      return Videos.update({
        subresource: self.video._id,
        fields: 'title,description,type,author,duration,tags,images,link,source,source_id,video_type,type,user,linked_category,explore_hide,draft,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,private,private,cover_justification,featured_justification,vtt_files,rating_configuration,rating_configuration,allow_comments,use_generative_ai'
      }, self.video).$promise.then(function(video) {
        self.setNoWatch();
        self.video.link = self.beforeUpdate.link;
        self.video.transcoding = true;
        Analyze.record({resource: 'modifications'}, {document: video._id, type: 'video'});
        Application.analyticsProvider.trackEvent('video_updated', {content: video._id, content_type: 'video', title: video.title});
        self.updateIndicator = false;
        self.editSaved = true;
        Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.video_savedPt1'] + ' ' + $filter('limitTo')(self.video.title, 25) + (self.video.title.length > 25 ? '[...]' : '') + ' ' + self.translations['modules.notifications.video_savedAsDraft'], duration: 5});
        if (trackState && typeof trackState.section === 'number') {
          trackState.contentId = video._id;
          trackState.contentTitle = video.title;
          Application.trackState.set(trackState);
          Application.navigation.goTo('/edit/tracks/' + trackState.track);
          return;
        }
        if (trackState && !next) {
          Application.navigation.goTo('/edit/tracks/' + trackState.track);
        }
      }).catch(function(error) {
        self.updateIndicator = false;
        if (error.data && error.data.status === 401 && error.data.message) {
          Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
        }
        console.log('Error in update: ', err);
      });
    };

    self.createVideo = function() {
      if (!self.newVideo || self.video._id) {
        return;
      }

      self.updateIndicator = true;
      self.video.user = self.user._id;
      if(self.user.is_collaborator) {
        self.video.approval_required = true;
        self.video.approved = false;
      }
      Videos.create(self.video).$promise
      .then(function(video) {
        self.setNoWatch();
        Analyze.record({resource: 'creations'}, {document: video._id, type: 'video'});
        Application.analyticsProvider.trackEvent('video_created', {content: video._id, type: 'video', title: video.title});
        self.updateIndicator = false;
        Application.messaging.addMessage({type: 'success', text: (self.translations['modules.notifications.video_createdPt1'] + ' ' + $filter('limitTo')(self.video.title, 25) + (self.video.title.length > 25 ? '[...]' : '') + ' ' + self.translations['modules.notifications.video_savedPt2']), duration: 5});
        self.editSaved = true;
        if (trackState) {
          trackState.contentId = video._id;
          trackState.contentTitle = video.title;
          Application.trackState.set(trackState);
          Application.navigation.goTo('/edit/tracks/' + trackState.track);
          return;
        }
        Application.navigation.goTo('/view/videos/' + video._id);
      }).catch(function(error) {
        self.updateIndicator = false;
        if (error.data && error.data.status === 401 && error.data.message) {
          Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
        }
        console.log('Error in video create: ', err);
      });
    };

    self.removeVideo = function() {
      if (!self.video._id) {
        return;
      }

      self.updateIndicator = true;
      self.archiveInfo = {};
      Viewables.archive({content: [{id: self.video._id, type: 'video'}]}).$promise
          .then(function(results) {
            self.archiveInfo.results = results;
            self.archiveInfo.show = results.in_track?.length || results.in_workflow?.length || results.in_journey?.length;
            self.updateIndicator = false;
            self.showDelete = false;
            if (self.archiveInfo.show) {
              return;
            }
            self.editSaved = true;
            Analyze.record({resource: 'deletions'}, {document: self.video._id, type: 'video'});
            Application.analyticsProvider.trackEvent('video_deleted', {content: self.video._id, type: 'video', title: self.video.title});
            Application.messaging.addMessage({type: 'success', text: 'The video was successfully removed.', duration: 5});
            Application.navigation.goTo('/admin/content');
          }).catch(function(err) {
        self.editSaved = true;
        self.updateIndicator = false;
        self.showDelete = false;
        Application.messaging.addMessage({type: 'error', text: self.translations['edit.videos.upload_error'], duration: 5});
      });
    };

    self.goBack = function() {
      if (!self.denied || !self.backLocation) {
        Application.navigation.back();
        self.denied = true;
        return;
      }
      self.denied = true;
      var location = self.backLocation.split('/#/');
      if (location.length !== 2) {
        Application.navigation.back();
        return;
      }
      Application.navigation.goTo(location[1]);
    };

    self.surveyAssociation = {
      surveysData: [],
      surveyIds: [],
      omittedContentTypes: SurveyHelper.chipSearchOmittedContentTypes,
      initialIdsByType: {survey: []},
      initSurveyData: function() {
        self.surveyAssociation.initialIdsByType.survey = self.video.surveys;
        self.surveyAssociation.surveyIds.push(self.video.surveys[0].survey_id);
      }
    };

    self.partners = {
    partnerPermission: 'tenant',
    changePermission: (permission) => {
      self.partners.partnerPermission = permission;
    }
  }

    self.initialize = function() {
      if (!Authorization.hasValidAuthToken()) {
        if (Application.navigation.isRouteSecure()) {
          Application.navigation.goToSignIn();
        }
      }
      if (self.user.role !== 'admin' && self.user.role !== 'creator' && !self.user.is_collaborator) {
        Application.navigation.goTo('/explore');
        return;
      }
      self.useGenerativeAIChosen = true;
      if (self.newVideo) {
        self.useGenerativeAIChosen = false;
        self.video = video;
        if (self.user.is_collaborator) {
          self.video.privacy_collaborators.push(self.user._id);
        }
        self.startEditWatch();
        return;
      }

      AdminContent.get({
        subresource: routeParameters.id,
        fields: 'title,company,description,transcoding,transcript,type,author,tags,duration,images,link,source,source_id,video_type,type,user,linked_category,explore_hide,draft,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,private,cover_justification,featured_justification,createdAt,vtt_files,rating_configuration,allow_comments,surveys,partner_permissions,text_generation_status,use_generative_ai',
        types: 'videos'
      }, async function(data) {
        self.setNoWatch();
        if (!data || (data.company !== self.authtoken.company._id) || (self.user.is_collaborator && data.privacy_collaborators.length && data.privacy_collaborators.indexOf(self.user._id) === -1)) {
          Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.videoNotEditable'], duration: 5});
          self.editSaved = true;
          Application.navigation.goToHome();
        }
        self.video = data;
        self.confirmAIOnce =
          self.video.text_generation_status === 'completed' ||
          self.video.text_generation_status === 'failed'
            ? true
            : false;
        if (self.video.use_generative_ai && self.video.text_generation_status === 'in_progress') {
          self.getGeneratedText();
        }
        if (!self.video.privacy_collaborators) {
          self.video.privacy_collaborators = [];
        }
        if (self.video.privacy_collaborators.length && !self.user.is_collaborator) {
          self.showCollaborators = true;
        }
        if (!self.video.images) {
          self.video.images = {};
        }
        if (self.video.draft && !self.video.transcoding) {
          self.activeTab = 'preview';
          Application.messaging.addMessage({text: self.translations['modules.notifications.clickToAddToExplore'], duration: 10});
        }
        if (self.video.surveys.length) {
          self.surveyAssociation.initSurveyData();
        }
        if (self.video.partner_permissions) {
          self.partners.partnerPermission = self.video.partner_permissions;
        }
        self.startEditWatch();
      }, function(error) {
        console.log('Error occured getting video ', routeParameters.id, error);
      });
    };

    self.setNoWatch = function() {
      self.noWatch = true;
      setTimeout(function() {
        self.noWatch = false;
      }, 500);
    };

    self.startEditWatch = function() {
      $scope.$watch('video.video', function(newVal, oldVal) {
        if (self.noWatch || !newVal || newVal === oldVal) {
          return;
        }
        self.editSaved = false;
      }, true);

      $scope.$watch('video.surveyAssociation.surveysData', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.surveyAssociation.surveyIds = newVal.map(survey => survey._id);
      }, true);

      $scope.$watch('video.surveyAssociation.surveyIds', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.video.surveys = newVal.map(surveyId => ({survey_id: surveyId}));
      }, true);
      $scope.$watch('video.partners.partnerPermission', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.video.partner_permissions = newVal;
      }, true);
    };

    self.getGeneratedText = function () {
      if (self.video.text_generation_status === 'completed') {
        return;
      }
    Videos.get({
      videoId: self.video._id,
      fields: 'title,company,description,type,author,duration,tags,images,link,source,source_id,source_v2,source_id_v2,video_type,type,user,linked_category,explore_hide,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grade,privacy_groups,private,downloadable,cover_justification,featured_justification,completion_percent,embed,embed_settings,rating_configuration,allow_comments,surveys,partner_permissions,text_generation_status,use_generative_ai,vtt_files'
    }).$promise.then(async function (data) {
      const status = data.text_generation_status;
      if (status) {
        switch (status) {
          case 'in_progress':
            setTimeout(()=> {
              self.getGeneratedText();
            }, 15000);
            break;
          case 'completed':
            if (!self.confirmAIOnce) {
              self.video.description = data.description;
              self.video.vtt_files = data.vtt_files;
              self.video.tags = data.tags;
              self.video.text_generation_status = 'completed';
              Application.messaging.addMessage({
                type: 'success',
                text: 'Text Generation Completed',
                duration: 7,
              });
              self.confirmAIOnce = true;
            }
            break;
          case 'failed':
            if (!self.confirmAIOnce) {
              Application.messaging.addMessage({
                type: 'error',
                text: 'Text Generation Failed',
                duration: 7,
              });
              self.confirmAIOnce = true;
            }
            break;
          default:
            break;
        }
      }
    }).catch(function (error) {
      console.log('Error occurred getting video ', routeParameters.id, error);
    });
  }


    $translate([
      'modules.notifications.clickToAddToExplore',
      'edit.general.notification_fieldsMissing',
      'modules.notifications.video_publishedPt1',
      'modules.notifications.video_publishedPt2',
      'modules.notifications.video_savedPt1',
      'modules.notifications.video_savedPt2',
      'modules.notifications.video_createdPt1',
      'modules.notifications.video_createdPt2',
      'modules.notifications.video_removedPt1',
      'modules.notifications.video_removedPt2',
      'modules.notifications.video_savedAsDraft',
      'modules.notifications.videoNotEditable',
      'edit.videos.preview_transcoding',
      'edit.videos.cc_added',
      'edit.videos.cc_removed',
      'modules.notifications.content_issue_updating',
      'edit.videos.upload_error'
    ]).then(function(translations) {
      self.translations = translations;
      self.initialize();
    });

  }]);
